module.exports = __webpack_public_path__ + "static/media/video.d4be350a.svg";